import{NATIONAL_CURRENCY as o}from"./constants.js";const r=r=>{var n;if(!r)return!1;const t="string"==typeof r?r:null===(n=null==r?void 0:r.price)||void 0===n?void 0:n.currency;return t!==o&&Boolean(t)};export{r as default};
